// src/pages/WelcomeAnimation.js
import React from "react";
import "./WelcomeAnimation.css";

function WelcomeAnimation() {
  return (
    <div className="welcome-animation-container">
      <svg viewBox="0 0 300 240" fill="none" className="scene">
        <g stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none">
          <path
            className="bookpath"
            pathLength="1"
            d="M150 60 C150 50 130 44 105 44 C90 44 78 47 70 52 V150 C78 145 90 142 105 142 C130 142 150 148 150 158 C150 148 170 142 195 142 C210 142 222 145 230 150 V52 C222 47 210 44 195 44 C170 44 150 50 150 60 Z"
          />
          <path className="bookpath" pathLength="1" d="M150 60 V158" strokeWidth="1.4" />
        </g>
        <g strokeLinecap="round">
          <line className="line1" pathLength="1" x1="163" y1="88" x2="218" y2="88" stroke="#fff" strokeWidth="1.6" />
          <line className="glow1" pathLength="1" x1="163" y1="88" x2="218" y2="88" strokeWidth="4" />
          <line className="line2" pathLength="1" x1="163" y1="107" x2="209" y2="107" stroke="#fff" strokeWidth="1.6" />
          <line className="glow2" pathLength="1" x1="163" y1="107" x2="209" y2="107" strokeWidth="4" />
          <line className="line3" pathLength="1" x1="163" y1="126" x2="214" y2="126" stroke="#fff" strokeWidth="1.6" />
          <line className="glow3" pathLength="1" x1="163" y1="126" x2="214" y2="126" strokeWidth="4" />
        </g>
        <circle className="ring" cx="228" cy="45" r="16" fill="none" strokeWidth="2" />
        <g className="badge">
          <circle cx="228" cy="45" r="16" fill="#fff" />
          <path d="M221 45 L226 50 L236 39" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </g>
        <g>
          <rect x="70" y="184" width="160" height="12" rx="6" stroke="rgba(255,255,255,0.4)" strokeWidth="1.4" fill="none" />
          <rect className="barfill" x="72" y="186" width="0" height="8" rx="4" />
        </g>
      </svg>
      <p className="artcaption">
        See a passage read, understood, and mastered — one step at a time.
      </p>
    </div>
  );
}

export default WelcomeAnimation;
